import React, { useEffect, useState } from 'react'

import Public from '@/helpers/PageTypes/Public'

import SEO from '@/components/SEO'
import BackToTopButton from '@/components/BackToTopButton'
import FooterUnsigned from '@/components/LandingPage/Footer'

import {
  Header,
  HeroBanner,
  LogosCarousel,
  SectionAppBioAtlas,
  SectionCtaBioAtlas,
  SectionCtaCytology,
  SectionDepoimentos,
  SectionEnriquecaAulas,
  SectionEstudanteProfissional,
  SectionModulosBioAtlas,
  SectionResults,
  SectionSolucaoBioAtlas,
  SectionVantagensInstituicao
} from '@/components/LandingPageV2'

import AboutMedicalHarbour from '@/components/AboutMedicalHarbour/AboutMedicalHarbour'

import { useTranslation } from 'react-i18next'

const IndexPage = () => {
  const { t } = useTranslation()

  const [pageTitle, setPageTitle] = useState(
    ' - Interactive Digital Content for Health'
  )

  useEffect(() => {
    setPageTitle(` - ${t('subtitles.tabText')}`)
  }, [t])

  return (
    <Public>
      <SEO title={pageTitle} />

      <Header />
      <HeroBanner />

      <LogosCarousel />

      <SectionResults />
      <SectionEstudanteProfissional />
      <SectionVantagensInstituicao />
      <SectionEnriquecaAulas />
      <SectionCtaBioAtlas />
      <SectionSolucaoBioAtlas />
      <SectionModulosBioAtlas />
      <SectionCtaCytology />

      <SectionAppBioAtlas />
      <SectionDepoimentos />
      <AboutMedicalHarbour />

      <FooterUnsigned />
      <BackToTopButton threshold={700} />
    </Public>
  )
}

export default IndexPage
